<template>
  <layout-register :step="step" :title-step="$t('m156')">
    <div class="container-fluid p0">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-sm-12 col-12">
          <div class="big-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </layout-register>
</template>
<script>
export default {
  name: 'ValidatePayment',
  data() {
    return {
      step: 9,
      titlePage: this.$t('m181'),
    };
  },
  methods: {
    getRegistrationStep() {
      this.$store
        .dispatch('register/getRegistrationStep')
        .then(registrationStep => {
          this.$router.push({ name: registrationStep });
        });
    },
  },
  mounted() {
    this.getRegistrationStep();
  },
};
</script>
